export const PERMISSIONS = {
  DASHBOARD: {
    VER: 'dashboard.ver',
    FINANZAS: 'dashboard.finanzas',
    VENTAS: 'dashboard.ventas',
    COMPRAS: 'dashboard.compras',
  },
  PROYECTOS: {
    VER: 'proyectos.ver',
    CREAR: 'proyectos.crear',
    EDITAR: 'proyectos.editar',
    ELIMINAR: 'proyectos.eliminar',
  },
  UNIDADES: {
    VER: 'unidades.ver',
    EDITAR: 'unidades.editar',
  },
  COMERCIAL: {
    CLIENTES_VER: 'clientes.ver',
    CLIENTES_EDITAR: 'clientes.editar',
    PRECIOS_VER: 'precios.ver',
    PRECIOS_EDITAR: 'precios.editar',
    VENTAS_VER: 'ventas.ver',
    VENTAS_CREAR: 'ventas.crear',
  },
  COMPRAS: {
    PROVEEDORES_VER: 'proveedores.ver',
    PROVEEDORES_EDITAR: 'proveedores.editar',
    OC_VER: 'oc.ver',
    OC_CREAR: 'oc.crear',
    OC_EDITAR: 'oc.editar',
    FACTURAS_VER: 'facturas_proveedor.ver',
    FACTURAS_EDITAR: 'facturas_proveedor.editar',
  },
  CONTABILIDAD: {
    MODULO_VER: 'contabilidad.ver',
    MODULO_OPERAR: 'contabilidad.operar',
    COBRANZAS_VER: 'cobranzas.ver',
    COBRANZAS_OPERAR: 'cobranzas.operar',
    CAJAS_VER: 'cajas.ver',
    CAJAS_OPERAR: 'cajas.operar',
    TRANSACCIONES_VER: 'transacciones.ver',
    CUENTAS_CORRIENTES_VER: 'cuentas_corrientes.ver',
    REPORTES_VER: 'reportes.ver',
  },
  CONFIGURACION: {
    VER: 'config.ver',
    EDITAR: 'config.editar',
  },
  USUARIOS_ROLES: {
    USUARIOS_VER: 'usuarios.ver',
    USUARIOS_GESTIONAR: 'usuarios.gestionar',
    ROLES_VER: 'roles.ver',
    ROLES_GESTIONAR: 'roles.gestionar',
  },
} as const;

export type PermissionCode =
  (typeof PERMISSIONS)[keyof typeof PERMISSIONS][keyof (typeof PERMISSIONS)[keyof typeof PERMISSIONS]];
